module.exports = __webpack_public_path__ + "static/media/VirginiaTech_logo.6e28a84d.png";